export default {
    key: 'adventure',
    common: {
        productName: 'core.productNames.adventure',
        splashMessage: 'offerFlow.splashMessage.adventure',
        headingAside: 'offerFlow.headingAside.adventure',
    },
    stepActivitySelection: {
        heading: 'offerFlow.pages.stepActivitySelection.heading.common',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.adventure',
    },
    stepActivityOptions: {
        heading: 'offerFlow.pages.stepActivityOptions.heading.common',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
